import { createContext, type PropsWithChildren, useContext } from 'react';

import { type SpringValue, type TransitionState } from '@react-spring/web';

import { type ModalName } from '@/modals-names';

type ModalTransitionStyles = Record<string, SpringValue<any>>;

interface ModalContextType {
  name: ModalName;
  style: ModalTransitionStyles;
  transition: TransitionState<boolean, any>;
}

/**
 * Context for transition styles of modal
 */
const ModalContext = createContext<ModalContextType>({} as ModalContextType);

export const useModalContext = () => useContext<ModalContextType>(ModalContext);

export const ModalContextProvider = ({
  name,
  style,
  transition,
  children,
}: PropsWithChildren<{
  name: ModalName;
  style: ModalTransitionStyles;
  transition: TransitionState<boolean, any>;
}>) => {
  return (
    <ModalContext.Provider value={{ name, style, transition }}>
      {children}
    </ModalContext.Provider>
  );
};
